import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CategorizeContainer } from '../../../../flows/categorizeTransacrions/CategorizeContainer';
import { useGetUncategorizedTotalNumOfRecords } from '../../../../hooks/query/useGetUncategorizedTransactionsDataForScheduleCQuery';
import { useStore } from '../../../../store';
import { Preloader } from '../Preloader';
import Heading from '../../../../generic-components/Heading';
import { MasterOfCategorize } from './MasterOfCategorize';
import { CATEGORIZE_DISCLAIMER_MAP, STYLES } from '../../consts';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { getFormNumber } from '../../utils';
import { featureAccess, LimitedFeatureType } from '../../../../services/appAccess.service';
import { FEATURE_FLAG } from '../../../../constants/general';
import { FeatureAccess } from '../../../AccountSettings/components/rolesAndPermissions/PermissionsList';
import { VIEWS_MAP } from '../../../../router/constants';

const { CATEGORIZE } = STYLES;

interface IProps {
  filterYear: number;
}

export const Categorize = ({ filterYear }: IProps) => {
  const navigate = useNavigate();
  const { formType } = useParams();
  const { t } = useTranslation();
  const [toggleData, setToggleData] = useState<{ incomeTrxCnt: number; expenseTrxCnt: number }>();
  const [isDoneCategorize, setIsDoneCategorize] = useState<boolean>(false);
  const { customerId } = useStore((state) => state.user);
  const location = useLocation();

  const getQueryStr = (type: string) => {
    if (type === 'INCOME' && location.pathname.includes(VIEWS_MAP.EXPENSES)) return '';
    return `&startTime=${filterYear}-01-01&endTime=${filterYear}-12-31&categorizationType=${type}`;
  };
  const { mutateAsync: getUncategorizedTrxCount, isLoading } = useGetUncategorizedTotalNumOfRecords();
  const categorizePermission = featureAccess(
    FEATURE_FLAG.CATEGORIZATION.FEATURE,
    LimitedFeatureType.TransactionListCategorize,
  );

  function getToggleData(shouldSkipNavigateOnZeroTrx?: boolean) {
    Promise.all([
      getUncategorizedTrxCount({ q: getQueryStr('INCOME'), customerId }),
      getUncategorizedTrxCount({ q: getQueryStr('EXPENSE'), customerId }),
    ]).then((values: [number, number]) => {
      const incomeTrxCnt = values[0];
      const expenseTrxCnt = values[1];
      if (!(incomeTrxCnt + expenseTrxCnt) && !shouldSkipNavigateOnZeroTrx) {
        navigate(`/tax-forms/${formType}/generate`);
      }
      trackMixPanel(`View form ${getFormNumber(formType)} Categorization Screen`);
      setToggleData({ incomeTrxCnt, expenseTrxCnt });
    });
  }

  useEffect(() => {
    getToggleData();
  }, [filterYear]);

  return isLoading || !toggleData ? (
    <Preloader />
  ) : isDoneCategorize ? (
    <MasterOfCategorize year={filterYear} />
  ) : (
    <div className={CATEGORIZE.WRAPPER}>
      <Heading
        title={t(CATEGORIZE_DISCLAIMER_MAP[formType as keyof typeof CATEGORIZE_DISCLAIMER_MAP])}
        className={CATEGORIZE.HEADER}
      />
      <CategorizeContainer
        handleFinishCategorize={() => {
          trackMixPanel(`Act on form ${getFormNumber(formType)} Categorization Screen`, {
            Action: `${(toggleData?.expenseTrxCnt || 0) + (toggleData?.incomeTrxCnt || 0)} of transactions`,
          });
          setIsDoneCategorize(true);
        }}
        filterYearValue={filterYear}
        onMutateFinish={() => {}}
        toggleData={toggleData}
        containerClassName={CATEGORIZE.CONTAINER}
        navSwitchClassName={CATEGORIZE.NAV_SWITCH}
        shouldHideHeader
        actionTypesToHide={['categorizeNotNow']}
        isReadOnlyMode={categorizePermission !== FeatureAccess.READ_WRITE}
      />
    </div>
  );
};
